class CountdownTimer extends HTMLElement {
    constructor() {
      super();
      this.interval = setInterval(this.updateTime.bind(this), 1000);
      this.updateTime();
    }
    updateTime() {
      const currentTimeUK = new Date().toLocaleString("en-US", { timeZone: "Europe/Amsterdam" });
      const endTime = new Date(currentTimeUK);
      endTime.setHours(parseInt(this.dataset.endTime), 0, 0); // 3:00 PM
      const currentTime = new Date(currentTimeUK);
  
      if (currentTime.getHours() >= 15) {
        endTime.setDate(endTime.getDate() + 1); // set to tomorrow
      }
  
      const timeDifference = endTime - currentTime;
  
      let hours = String(Math.floor(timeDifference / (1000 * 60 * 60))).padStart(2, '0');
      let minutes = String(Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, '0');
      let seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);
  
      this.innerHTML = `${hours}:${minutes}`;
    }
  }
  if (!window.customElements.get('countdown-timer')) {
    window.customElements.define('countdown-timer', CountdownTimer);
  }